import React from "react";
import PropTypes from "prop-types";
import { ResponsiveBar } from "@nivo/bar";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

const HoursByUser = ({ auth, pm, data }) => {
  const keyNames = [
    ...new Set(data.reduce((acc, curr) => [...acc, ...curr.users], []))
  ]
    .sort()
    .reverse();

  const chartData = data.map((x) => {
    const breakdown = x.breakdown.reduce(
      (obj, it) => ({ ...obj, [it.user]: it.billableHours }),
      {}
    );
    return {
      ...x,
      ...breakdown,
      index: x._id.month
        ? `${MONTHS[x._id.month - 1]} ${x._id.year}`
        : `${x._id.week} ${x._id.year}`
    };
  });

  const textColor = auth?.isNightMode ? "#ffffff" : "#000000";

  return pm.totalBillableHours > 0 ? (
    <div style={{ height: "500px" }}>
      <ResponsiveBar
        data={chartData}
        keys={keyNames}
        indexBy="index"
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.2}
        colors={[
          "#CFE8F0",
          "#AFD9E7",
          "#8FCADD",
          "#6FBBD4",
          "#50ACCB",
          "#428DA7",
          "#336E82",
          "#254F5D",
          "#162F38"
        ]}
        groupMode="stacked"
        markers={[
          {
            axis: "y",
            value: pm.monthlyBudgetHours,
            lineStyle: { stroke: "black", strokeWidth: 2 },
            legend: "Budget Avg.",
            legendOrientation: "horizontal",
            textStyle: {
              fill: textColor
            }
          },
          {
            axis: "y",
            value: pm.currentBudgetHours,
            lineStyle: {
              stroke:
                pm.monthlyBudgetHours < pm.currentBudgetHours
                  ? "#fe703f"
                  : "#35d687",
              strokeWidth: 2
            },
            legend: "Current Avg.",
            legendOrientation: "horizontal",
            textStyle: {
              fill: textColor
            }
          }
        ]}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -30
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Hours",
          legendPosition: "middle",
          legendOffset: -40
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        theme={{
          labels: {
            text: { fill: textColor }
          },
          axis: {
            ticks: {
              text: { fill: textColor }
            },
            legend: {
              text: { fill: textColor }
            }
          },
          legends: {
            text: { fill: textColor }
          },
          markers: {
            text: {
              fill: textColor
            }
          }
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        animate
        motionStiffness={90}
        motionDamping={15}
        tooltip={(e) => (
          <div
            style={{
              padding: 10,
              minWidth: 300,
              color: auth?.isNightMode ? "black" : "white",
              backgroundColor: auth?.isNightMode
                ? "rgba(255, 255, 255, 0.65)"
                : "rgba(0, 0, 0, 0.65)",
              backdropFilter: "blur(7px)",
              borderRadius: 4,
              textAlign: "center"
            }}
          >
            <span>
              {e.indexValue || ""} Billable: {e.data?.billableHours} hours
            </span>
            <hr
              style={{
                margin: 5
              }}
            />
            <span>
              {e.indexValue || ""} Actual: {e.data?.actualHours} hours
            </span>
            <hr
              style={{
                margin: 5
              }}
            />
            <span>
              {e.id || ""}: {e.value} hours
            </span>
          </div>
        )}
      />
    </div>
  ) : null;
};

HoursByUser.propTypes = {
  auth: PropTypes.object.isRequired,
  pm: PropTypes.object,
  data: PropTypes.array
};

export default HoursByUser;
